// extracted by mini-css-extract-plugin
export var actionButton = "_cs-0";
export var attachmentLine = "_cs-1";
export var fileInput = "_cs-2";
export var fileUploadWrapper = "_cs-4";
export var footer = "_cs-3";
export var modalContent = "_cs-5";
export var paperclip = "_cs-6";
export var quillEditor = "_cs-7";